import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    CircularProgress,
    Paper
} from "@material-ui/core";
import * as Yup from "yup";

import { BackButton } from '../../sc-utilities';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: 'right'
    }
});

const WarehouseForm = props => {
    const { classes, formSettings, initialValues, loading, handleSubmit, translations } = props;

    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, handleChange, handleBlur, handleSubmit } = formikProps;

                    const inputProps = {
                        autoComplete: 'new-password',
                        form: {
                            autoComplete: 'off',
                        },
                    }

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />
                            <TextField
                                name="Description"
                                value={values.Description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Description && touched.Description)}
                                placeholder={translations["description"] || "Description"}
                                label={translations["description"] || "Description"}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />
                            <TextField
                                name="Location"
                                value={values.Location}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Location && touched.Location)}
                                placeholder={translations["location"] || "Location"}
                                label={translations["location"] || "Location"}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />
                            <TextField
                                name="ContactPerson"
                                value={values.ContactPerson}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ContactPerson && touched.ContactPerson)}
                                placeholder={translations["contact_person"] || "Contact person"}
                                label={translations["contact_person"] || "Contact person"}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />
                            <div className={classes.buttons}>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={loading || !(isValid && dirty)}
                                    >
                                        {loading ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};

export default withStyles(styles, { withTheme: true })(WarehouseForm);

/**
 * Translations:
 *  name
 *  contact_person
 */